module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-hero-image-3-f0075d2bca34c6f91c96c4ad2ce0a0f8.jpg";